package com.essntl.features.task.ui.addedittask

import androidx.compose.runtime.MutableState
import androidx.compose.runtime.mutableStateOf
import com.essntl.core.utils.viewmodel.PaginationState
import com.essntl.core.utils.viewmodel.State
import com.essntl.features.profile.domain.model.ProfileModel
import com.essntl.features.task.domain.model.TaskModel
import com.essntl.features.task.ui.sharedtask.SharedTaskState

data class AddEditTaskState(
    val sharedTaskState: SharedTaskState = SharedTaskState(),
    val task: MutableState<TaskModel> = mutableStateOf(TaskModel.empty),
    val getTask: State<TaskModel> = State(),
    val getProfile: State<ProfileModel> = State(),
    val getCurrentProfile: State<ProfileModel> = State(),
    val addEditTask: State<TaskModel> = State(),
    val isEditEnabled: Boolean = false,
    val getAllProfile: PaginationState<ProfileModel> = PaginationState(),
) {
    val isLoading
        get() = getTask.isLoading ||
            getProfile.isLoading

    val isFailure
        get() = getTask.isFailure ||
            getProfile.isFailure
}
